import { Component, Input } from '@angular/core';

@Component({
  selector: 'dls-example-viewer',
  templateUrl: './example-viewer.component.html',
  styleUrls: ['./example-viewer.component.scss']
})
export class ExampleViewerComponent {

  public codeBlock: boolean;

  // To set title to the toolbar
  @Input() title: string;

  // To set title to the toolbar
  @Input() color: string;

  constructor() {
    // Default state for code block i.e. hidden
    this.codeBlock = false;

    // Default toolbar color
    this.color = 'accent';
  }

  // Toggles code block
  public toggleCodeBlock() {
    this.codeBlock = !this.codeBlock;
  }
}
